export enum HelpInfo {
  GeneralCase = 'General Case',
  FuneralCase = 'Funeral Case',
  HospitalCase = 'Hospital Case',
  User = 'user',
  ExternalData = 'External Data',
  NationalDrugFormulary = 'national_drug_formulary',
  Broker = 'broker',
  ApplicationCapture = 'Application Capture',
}

export enum HelpInfoInputName {
  MessageID = 'Message ID',
  CorrelationID = 'Correlation ID'
};